import { AlarmPageContent } from "../../components/organisms/AlarmPageConent";
import { MoreTemplates } from "../../components/template/MoreTemplates";

const AlarmPage = () => {
  return (
    <MoreTemplates pageTitle="알림" pageHeaderTitle="홈" background="white">
      <AlarmPageContent />
    </MoreTemplates>
  );
};

export default AlarmPage;
